<template>
    <div class="side-box">
        <v-layout justify-space-between align-center class="side-box-header">
            <div class="side-box-title">{{$t('sessionInfo')|capitalize}}</div>
            <v-icon @click="toggleSessionInfo">mdi-close</v-icon>
        </v-layout>
        <div class="side-box-content side-box-session-info-list" :class="{'sidebar-full-height': !favoriteTags.length}">
            <v-expansion-panel
                    v-model="panel"
                    expand
            >
                <v-expansion-panel-content
                        v-for="(item, i) in sessionInfo"
                        :key="i"
                        expand-icon
                >
                    <template v-slot:header>
                        <div>
                            <ul>
                                <li class="header-panel">
                                    <span class="label">{{$t('completedAt')|capitalize}}: </span>
                                    {{item.updated | moment("DD/MM/YYYY HH:mm")}}
                                </li>
                                <li class="header-panel">
                                    <span class="label">{{$t('supportedBy')|capitalize}}: </span>
                                    {{item.user.email}}
                                </li>
                            </ul>
                        </div>
                    </template>
                    <v-card color="#F7F7FC" flat>
                        <v-card-text>
                            <v-layout wrap>
                                <v-flex xs12 style="padding: 9px 0px">
                                    <span class="label">{{$t('requestDescription')|capitalize}}</span>
                                </v-flex>
                                <v-flex xs12>
                                    <v-textarea
                                            solo
                                            background-color="#EDEDF2"
                                            auto-grow
                                            flat
                                            rows="3"
                                            v-model="item.description"
                                            :rules="formRules.required"
                                            :disabled="user.id !== item.user.id"
                                    ></v-textarea>
                                </v-flex>
                                <v-flex xs12 style="padding: 9px 0px">
                                    <span class="label">{{$t('sessionNotes')|capitalize}}</span>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                            solo
                                            background-color="#EDEDF2"
                                            flat
                                            v-model="item.notes"
                                            :disabled="user.id !== item.user.id"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding: 9px 0px">
                                    <span class="label">{{$t('topic')|capitalize}}</span>
                                </v-flex>
                                <v-flex xs12  v-if="typeof item.topic === 'string'">
                                    <v-text-field
                                            solo
                                            background-color="#EDEDF2"
                                            flat
                                            v-model="item.topic"
                                            :disabled="user.id !== item.user.id"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 v-if="typeof item.topic === 'object'">
                                    <v-layout wrap>
                                        <v-flex xs12 style="padding: 9px 0px" v-for="(name, level, idx) in item.topic" v-bind:key="idx">
                                            <span class="label">Level {{idx + 1}}: {{name}}</span>
                                        </v-flex>
                                    </v-layout>
                                    <treeselect
                                            :options="options"
                                            v-model="item.topic_val"
                                            :normalizer="normalizer"
                                            :max-height="110"
                                            @select="(node, id) => updateTopic(node, i)"
                                    >
                                    </treeselect>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn flat outline small color="#0052CC" @click="saveSessionInfoBtn(i)"
                                   :disabled="user.id !== item.user.id">{{$t('save')|capitalize}}
                            </v-btn>
                            <v-spacer></v-spacer>
                            <a href="#" @click="openConversationHistoryBySession({sessionId: item.session_id, user: item.user, updated: item.updated})">
                                <img style="position: relative;top: 5px;"
                                     src="/assets/icons/platform/conversation_history.svg"/>
                                <span style="padding: 0px 8px">{{$t('conversationHistory')|capitalize}}</span>
                            </a>
                        </v-card-actions>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </div>
        <v-layout justify-space-between align-center class="side-box-header-info">
            <div class="side-box-title">{{$t('favoriteTags')| capitalize}}</div>
        </v-layout>
        <div class="side-box-favorite-tags" style="overflow: auto">
            <div class="favorite-tags" v-if="favoriteTags.length > 0">
                <v-chip class="ma-2" color="#F6722F" label text-color="white" disabled v-for="tag in favoriteTags" :key="tag['code']">
                    <v-icon left>mdi-label</v-icon>
                    {{tag['name']}}
                </v-chip>
            </div>
        </div>
    </div>
</template>
<script>
import BotService from "@/services/bot.service";
import FormMixin from '@/mixins/FormMixin'
import {mapActions, mapMutations, mapState} from "vuex";
import Vue from 'vue'
import Treeselect from '@riophae/vue-treeselect'
import CustomerService from '@/services/customer.service'
import _ from "lodash";

export default {
        name: "SessionInfo",
        mixins: [FormMixin],
        components: { Treeselect },
        data() {
            return {
                panel        : [],
                sessionInfo  : [],
                formHasErrors: [],
                formError    : false,
                options      : [],
                favoriteTags : [],
                optionsFlat: [],
            }
        },
        computed: {
            ...mapState(['user', 'notifyBotChat']),
            form() {
                return {
                    description: '',
                }
            },
        },
        mounted() {
            this.loadSessionInfo();
            this.getCustomInfo();
        },
        watch: {
            notifyBotChat: {
                handler(val) {
                    if(val.type === this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.MARK_AS_DONE) {
                        this.loadSessionInfo();
                        this.getCustomInfo();
                    }
                }
            }
        },
        methods: {
            ...mapMutations('sideBox', [
               'toggleSessionInfo'
            ]),
            ...mapActions('dialog', ['openConversationHistoryBySession']),
            flatOptions(options, result) {
                for (let option of options) {
                    let cdata = _.pick(option, 'id', 'pid', 'name');
                    result.push(cdata)
                    if (option.children) {
                        this.flatOptions(option.children, result)
                    }
                }
            },
            customTopicValue(node, result) {
                result.unshift(node.name)
                if (node && node.pid!==0) {
                    let parent = _.find(this.optionsFlat, o=> o.id === node.pid)
                    this.customTopicValue(parent, result)
                }
            },
            updateTopic(node, index) {
                let topicArr = [];
                this.customTopicValue(node, topicArr);
                let topic = {};
                for (let i = 0; i< topicArr.length; i++) {
                    Object.assign(topic, {[`level_${i + 1}`]: topicArr[i]})
                }
                let sessionInfoItem = this.sessionInfo[index];
                sessionInfoItem.topic = topic;
                this.$set(this.sessionInfo, index, sessionInfoItem);
            },
            topicArr(topic) {
               return topic? topic.split("-") : [];
            },
            getCustomInfo() {
                let botCode = this.$route.params.bot_code;
                BotService.getCustomInfo(botCode)
                    .then((res)=>{
                        this.options = [];
                        this.options =  res.data.data.children
                        this.flatOptions(this.options, this.optionsFlat);
                    })
                    .catch(()=> {
                        this.$AppService.handleRequestError("Cannot get custom info")
                    });
                this.getFavoriteTags()
            },
            loadSessionInfo() {
                let botCode = this.$route.params.bot_code;
                let customerId = this.$route.params.senderId;
                BotService.getSessionInfo(botCode, customerId)
                    .then(res => {
                            this.sessionInfo = _.map(res.data.results, v => {
                                let topicVal = v.topic;
                                if (v.topic && typeof v.topic === "object") {
                                    let lastLv = Object.keys(v.topic).length;
                                    topicVal = v.topic[`level_${lastLv}`]
                                }
                                return _.assign({}, v, { topic_val: topicVal})
                            });
                        },
                        this.$AppService.handleRequestError('Cannot load session info')
                    )
            },
            getFavoriteTags() {
                this.favoriteTags = []
                let botCode       = this.$route.params.bot_code
                let customerId    = this.$route.params.senderId
                CustomerService.getSenderFavoriteTags(botCode, customerId)
                    .then(res => {
                            let favoriteData = []
                            if (_.isArray(res) && res.length > 0) {
                                favoriteData = res
                            } else if (res.data && _.isArray(res.data) && res.data.length > 0) {
                                favoriteData = res.data
                            }
                            if (favoriteData.length > 0) {
                                let tagIDs = {tags: []}
                                favoriteData.map(item => {
                                    tagIDs.tags.push(item._id)
                                })
                                CustomerService.getSenderFavoriteTagsDetails(botCode, tagIDs).then(item => {
                                    if (item.data && _.isArray(item.data) && item.data.length > 0) {
                                        this.favoriteTags = item.data
                                    }
                                }, this.$AppService.handleRequestError('Cannot load favorite tags title'))
                            }
                        },
                        this.$AppService.handleRequestError('Cannot load favorite tags')
                    )
            },
            saveSessionInfoBtn(i) {
                let botCode = this.$route.params.bot_code;
                let customerId = this.$route.params.senderId;
                this.formHasErrors[i] = false;
                Object.keys(this.form).forEach((s) => {
                    if (!this.sessionInfo[i][s]) this.formHasErrors[i] = true;
                });
                this.sessionInfo[i].topic = this.sessionInfo[i].topic_val === undefined ? null : this.sessionInfo[i].topic;
                if (!this.formHasErrors[i]) {
                    BotService.updateSessionInfo(botCode, customerId, this.sessionInfo[i]._id, this.sessionInfo[i].description, this.sessionInfo[i].notes, this.sessionInfo[i].topic)
                        .then(() => {
                            this.loadSessionInfo();
                            this.$AppService.toastSuccess('Save session info success');
                            Vue.set(this.panel, i, false)
                        }),
                        this.$AppService.handleRequestError('Cannot save session info')
                }
            },
            normalizer(node) {
                return {
                    id: node.name,
                    label: node.name
                }
            },

        },
    }
</script>
<style scoped lang="scss" src="../style/side-box.scss"></style>
<style scoped lang="scss" src="../style/staff.scss"></style>
<style scoped lang="scss" src="../style/session-info.scss"></style>
